var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemoteControlsSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21,26H11V11c0-0.5517578,0.4482422-1,1-1h5V8h-5c-1.6542969,0-3,1.3457031-3,3v18c0,1.6542969,1.3457031,3,3,3h8 c1.6542969,0,3-1.3457031,3-3V14h-2V26z M20,30h-8c-0.5517578,0-1-0.4482422-1-1v-1h10v1C21,29.5517578,20.5517578,30,20,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,0v2c5.5136719,0,10,4.4863281,10,10h2C31,5.3828125,25.6171875,0,19,0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,4v2c3.3085938,0,6,2.6914062,6,6h2C27,7.5888672,23.4111328,4,19,4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,8v2c1.1025391,0,2,0.8974609,2,2h2C23,9.7939453,21.2060547,8,19,8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoteControlsSmall);
export default __webpack_public_path__ + "static/media/remote-controls--small.e9335fa1059aad3d8c96f9088736309b.svg";
export { ForwardRef as ReactComponent };